import { priceSelectionListCoupon } from '../utils/getPriceSelectionList';
import getTotalsForSetOfTotals from '../utils/getTotalsForSetOfTotals';
import { pricingFields } from './couponCodePromotionFieldNames';

export const getCouponCodePromotion = (formFields, orderData) => {

  const couponCodePromotionTotals = getTotalsForSetOfTotals(
    pricingFields,
    formFields,
    orderData
  );
  return couponCodePromotionTotals;
};

export const getCouponCodePromotionSelections = formFields => {
  const selectionsList = priceSelectionListCoupon(pricingFields, formFields);
  return selectionsList;
};
